import {
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
} from '@mui/material';
import FormActionButtons from 'components/ui/form/FormActionButtons';
import FormSelectField from 'components/ui/form/FormSelectField';
import FormCurrencyField from 'components/ui/form/FormCurrencyField';
import FormSimpleSelectField from 'components/ui/form/FormSimpleSelectField';
import FormTextField from 'components/ui/form/FormTextField';
import { useFormik } from 'formik';
import useAxiosPrivate from 'hooks/useAxiosPrivate';
import useFormSubmit from 'hooks/useFormSubmit';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import FormDateField from 'components/ui/form/FormDateField';
import * as yup from 'yup';

// category_id  - kategoriya idsi
// sum          - xarajat summasi
// comment      - izoh (ixtiyoriy)
// isvalute     - valuta bo‘lsa 1, bo‘lmasa 0
// reason_id    - xarajat sababi idsi
// type         - xarajat turi (naqd, karta va h.k.)

const types = [
  {
    name: 'Obyekt',
    id: 1,
  },
  {
    name: 'Blok',
    id: 2,
  },
];

const validationSchema = yup.object({
  sum: yup.number().required('Valyuta tanlash majburiy!'),
  val: yup.number().required('Kategoriya tanlash majburiy!'),
  comment: yup.string().required('Kassani tanlash majburiy!')
});

const StaffAddEditModal = (props) => {
  const { open, setOpen, setRefetch, itemId, setItemId } = props;
  const { t } = useTranslation();
  const axiosPrivate = useAxiosPrivate();
  const [hasError, setHasError] = useState(false);
  const { submit, isSubmitting } = useFormSubmit();

  const formik = useFormik({
    initialValues: {
      sum: '',
      val: '',
      comment: ''
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      if (itemId) {
        submit(
          { type: 'postUpdate', contentType: 'simple' },
          values,
          '/admin/accounts',
          values.name,
          itemId,
          false,
          handleFinishRequest
        );
      }
    },
  });

  const { isLoading, isFetching } = useQuery({
    queryKey: '/admin/accounts/incomeedit/{itemId}',
    queryFn: async function () {
      const response = await axiosPrivate.get(`/admin/accounts/incomeedit/${itemId}`);
      return response.data.data;
    },
    onSuccess: (data) => {
      formik.setValues({
        sum: data?.sum || '',
        val: data?.val || '',
        comment: data?.comment || ''
      });
    },
    enabled: !hasError && !!itemId,
    onError: (error) => {
      setHasError(true);
    },
    retry: false,
  });

  const handleFinishRequest = () => {
    setRefetch(true);
    handleClose();
  };

  const handleClose = () => {
    setItemId('');
    setOpen(false);
    formik.resetForm();
  };
  useEffect(() => {
    formik.setFieldValue('reason_id', null);
    formik.setFieldValue('object_id', null);
  }, [formik.values.type]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      maxWidth='md'
      PaperProps={{
        className: '!base-border !shadow-none',
      }}
      disableEscapeKeyDown={true}
    >
      <DialogTitle
        id='alert-dialog-title'
        className='!text-center !bg-gray-100 !mb-2'
      >
          <span>Qabulni tahrirlash</span>
      </DialogTitle>

      <DialogContent>
        {isLoading || isFetching ? (
          <div className='circular-progress-box py-5'>
            <CircularProgress size={35} />
          </div>
        ) : (
          <form onSubmit={formik.handleSubmit}>
            <Grid
              container
              spacing={{ xs: 2, sm: 3, lg: 3 }}
              rowSpacing={1}
              columns={{ xs: 12, sm: 12, lg: 12 }}
            >

              <Grid item={true} lg={6} sm={6} xs={12}>
                <FormCurrencyField
                  delay={0}
                  label={'Summa'}
                  fieldName='sum'
                  formik={formik}
                />
              </Grid>
              <Grid item={true} lg={6} sm={6} xs={12}>
                <FormCurrencyField
                  delay={0}
                  label={'Summa'}
                  fieldName='val'
                  formik={formik}
                />
              </Grid>
              <Grid item={true} lg={12} sm={12} xs={12}>
                <FormTextField
                  delay={0.1}
                  label={'Izoh'}
                  fieldName='comment'
                  multiline
                  rows={3}
                  formik={formik}
                />
              </Grid>

              <Grid item={true} sm={12} xs={12}>
                <FormActionButtons
                  delay={0.6}
                  isSubmitting={isSubmitting}
                  formType='dialog'
                  setOpen={setOpen}
                  reset={formik.resetForm}
                />
              </Grid>
            </Grid>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default StaffAddEditModal;

/* import { Dialog, DialogContent, DialogTitle, Grid } from '@mui/material';
import { useFormik } from 'formik';
import * as yup from 'yup';

import FormSelectField from 'components/ui/form/FormSelectField';
import FormTextField from 'components/ui/form/FormTextField';
import useFormSubmit from 'hooks/useFormSubmit';

import FormActionButtons from 'components/ui/form/FormActionButtons';
import FormCurrencyField from 'components/ui/form/FormCurrencyField';

import { memo } from 'react';

const validationSchema = yup.object({
  sum: yup.number().required('Nom kiritish majburiy!'),
  val: yup.number().required('Obyekt tanlash majburiy!'),
});

  const { isLoading, isFetching } = useQuery({
    queryKey: '/admin/expense/edit/{itemId}',
    queryFn: async function () {
      const response = await axiosPrivate.get(`/admin/expense/edit/${itemId}`);
      return response.data.data;
    },
    onSuccess: (data) => {
      formik.setValues({
        isvalute: data?.isvalute ?? '',
        sum: data?.sum || '',
        reason_id: data?.reason_id || '',
        object_id: data?.object_id || '',
        comment: data?.comment || '',
        type: data?.type || '',
        category_id: data?.category_id || '',
        account_id: data?.account_id || '',
        date: data?.date || '',
      });
    },
    enabled: !hasError && !!itemId,
    onError: (error) => {
      setHasError(true);
    },
    retry: false,
  });

const AddEditModal = (props) => {
  const { open, setOpen, setRefetch, itemId } = props;
  const { submit, isSubmitting } = useFormSubmit();

  const formik = useFormik({
    initialValues: {
      sum: '',
      val: '',
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      if (itemId)
        submit(
          { type: 'post', contentType: 'simple' },
          values,
          `admin/account/incomeupdate/${itemId}`,
          values.name,
          itemId,
          true,
          handleFinishRequest
        );
    },
  });

  const handleFinishRequest = () => {
    setRefetch(true);
    handleClose();
  };

  const handleClose = () => {
    setOpen(false);
    formik.resetForm();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      maxWidth='md'
      PaperProps={{
        className: '!base-border !shadow-none',
      }}
      disableEscapeKeyDown={true}
    >
      <DialogTitle
        id='alert-dialog-title'
        className='!text-center !bg-gray-100 !mb-2'
      >
        <span>Kassa yaratish</span>
      </DialogTitle>

      <DialogContent>
        <form onSubmit={formik.handleSubmit}>
          <Grid
            container
            spacing={{ xs: 2, sm: 3, lg: 3 }}
            rowSpacing={1}
            columns={{ xs: 12, sm: 12, lg: 12 }}
          >
            {' '}
           
            <Grid item={true} lg={6} sm={6} xs={12}>
              <FormCurrencyField
                delay={0.1}
                label={'Valyuta'}
                fieldName='val'
                formik={formik}
              />
            </Grid>
            <Grid item={true} lg={6} sm={6} xs={12}>
              <FormCurrencyField
                delay={0.1}
                label={'Summasi'}
                fieldName='sum'
                formik={formik}
              />
            </Grid>
            <Grid item={true} lg={12} sm={12} xs={12}>
              <FormTextField
                delay={0.3}
                label={'Izoh'}
                fieldName='comment'
                rows={4}
                multiline
                formik={formik}
              />
            </Grid>
            <Grid item={true} sm={12} xs={12}>
              <FormActionButtons
                delay={0.4}
                isSubmitting={isSubmitting}
                formType='dialog'
                setOpen={setOpen}
                reset={formik.resetForm}
              />
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default memo(AddEditModal);
 */